module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.acf51bc4.svg";